export default function capitalize(string, allWords = false) {
  if (!allWords) {
    return string[0].toUpperCase() + string.substr(1).toLowerCase();
  }

  const words = string.split(' ');

  for (let i = 0; i < words.length; i += 1) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1).toLowerCase();
  }

  return words.join(' ');
}
